











































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { Validations } from "vuelidate-property-decorators";
import { required } from "vuelidate/lib/validators";
import FormValidation from "@/components/elements/form/FormValidation.vue";
import { EventBus } from "@/event-bus";
import { PaymentTerm } from "@/models/netsuite/netsuite";

@Component({
  components: {
    FormValidation
  }
})
export default class Payment extends Vue {
  protected methodModel: number | undefined = undefined;
  protected submitted = false;
  @Prop() method!: number;
  @Prop({ default: () => [] }) paymentTerms!: PaymentTerm[];

  @Validations()
  validations() {
    return {
      method: { required }
    };
  }
  @Watch("$v.$invalid", { deep: true })
  onFormChange(): void {
    if (this.submitted) {
      this.validateForm();
    }
  }
  @Watch("method", { immediate: true })
  updateMethodModel(): void {
    this.methodModel = this.method;
  }

  created() {
    EventBus.$on("submitCheckoutForm", this.validateForm);
  }

  beforeDestroy() {
    EventBus.$off("submitCheckoutForm");
  }

  protected validateForm(): void {
    this.submitted = true;
    this.$v.$touch();
    this.$emit("sendError", this.$v.$invalid, "payment");
  }

  /**
   * Have to explicitly call vuelidate ($v) methods if not using v-model
   */
  public updateItem(fieldValue: number, fieldName: string) {
    this.$emit(`update:${fieldName}`, fieldValue);
    if (this.submitted && this.$v[fieldName]) {
      this.$v[fieldName]!.$touch();
      this.validateForm();
    }
  }
}
